









































	import { MyActions } from '@/models/Store/State';
import Vue from 'vue';

    export default Vue.extend({
        name: "ArchiveDialogComp",
        data: () => ({
            newTermin: false,
        }),
        methods: {
            archiveOK: function(): void {
                this.$vStore.dispatch(MyActions.Archive, this.newTermin);
            },
            archiveCancel: function(): void {
                this.$vStore.dispatch(MyActions.CloseDialog);
            }
        },
        computed: {
            open: {
                get: function(): any {
                    return this.$vStore.getters.isDialogOpen('archive');
                },
                set: function(): void {
                    this.$vStore.dispatch(MyActions.CloseDialog);
                }
            }
        }
    })
